var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location"},[_c('img',{staticClass:"location-image",attrs:{"src":_vm.currentItem.image}}),_vm._v(" "),_c('p',{staticClass:"location-title"},[_vm._v(_vm._s(_vm.currentItem.name))]),_vm._v(" "),_c('p',{staticClass:"location-text"},[_vm._v(_vm._s(_vm.currentItem.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a6469e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Details.vue
// module id = null
// module chunks = 